(function($) {
    $(function() {
        graphQlUrl = window.graphqlURL;
        accessToken = window.accessToken;
        useCookiesForGraphQLResponse = window.useCookiesForGraphQLResponse;
        let USDollar = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        });

        let url = new URL(window.location.href);
        let ref = url.searchParams.get('customer_posted');
        if (ref) {
            url.searchParams.delete('customer_posted');
            history.replaceState(history.state, '', url.href);
        }

        // Price cookie variables
        var priceCookieTime = new Date();
        var time = priceCookieTime.getTime();
        time += 3600 * 1000;
        priceCookieTime.setTime(time);

        // Options json cookie variables
        var timeToAdd = 1000 * 60 * 60 * 24 * 7 * 4 * 6;
        var date = new Date();
        var expiryTime = parseInt(date.getTime()) + timeToAdd;
        date.setTime(expiryTime);
        var optionsJsonCookieTime = date.toUTCString();

        // Price Customization Start PLP
        getListPrices();
        window.addEventListener("locationchange", function() {
            setTimeout(function() {
                getListPrices();
            }, 1000);
            getListPrices();
        });

        function getListPrices() {
            $("input.product-sku").each(function() {
                getProductPrice($(this).val());
            });
        }

        function getCookie(name) {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts.length === 2) return parts.pop().split(';').shift();
        }

        function setCookie(name, value, expiry) {
            document.cookie = name + '=' + value + '; expires=' + expiry + '; path=/';
        }

        function getProductPrice(sku) {
            var cookiePriceHtml = getCookie(sku);
            var skuClass = sku;
            skuClass = skuClass.replaceAll(" ", ".");
            if (cookiePriceHtml == 'NA' && useCookiesForGraphQLResponse) {
                return;
            }
            if (cookiePriceHtml && useCookiesForGraphQLResponse) {
                $(".card-information." + skuClass).find(".price").html(cookiePriceHtml);
                //$(".product__info-container .price__container").html(cookiePriceHtml);
                return;
            }
            const storefrontPLPQuery = `
            {
              products(first: 1, sortKey:PRICE, query:"tag:` + sku + `") {
                edges {
                  node {
                    variants(first: 1) {
                      edges {
                        node {
                          priceV2 {
                            amount
                          }
                          compareAtPrice {
                            amount
                          }
                        }
                      }
                    } 
                  }
                }
              }
            }
            `;

            const storefrontRequestforPLPPQuery = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Shopify-Storefront-Access-Token': accessToken
                },
                body: JSON.stringify({
                    query: storefrontPLPQuery
                }),
            };
            fetch(graphQlUrl, storefrontRequestforPLPPQuery)
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! Status: ${response.status}`);
                    }
                    return response.json();
                })
                .then(data => {
                    var priceHtml = 'NA';
                    const productsData = data?.data?.products?.edges || []; // Safe access for products
                    productsData.forEach(eachCollection => {
                        try {
                            const priceObj = eachCollection.node.variants.edges[0].node.priceV2;
                            var price = false;
                            var specialPrice = false;
                            if (priceObj) {
                                price = priceObj.amount;
                                if (price) {
                                    //price = (Math.round(price * 100) / 100).toFixed(2);
                                    price = USDollar.format(price);
                                }
                            }
                            const specialPriceObj = eachCollection.node.variants.edges[0].node.compareAtPrice;
                            if (specialPriceObj) {
                                specialPrice = specialPriceObj.amount;
                                if (specialPrice) {
                                    //specialPrice = (Math.round(specialPrice * 100) / 100).toFixed(2);
                                    specialPrice = USDollar.format(specialPrice);
                                }
                            }
                            if (price) {
                                if (specialPrice) {
                                    priceHtml = "<span class='starting-from'>Starting from <span class='strike-through regular-price'>" + specialPrice + "</span></span><span class='special-price'>" + price + "</span>";
                                } else {
                                    priceHtml = "<span class='starting-from'>Starting from <span class='regular-price'>" + price + "</span></span>";
                                }
                                $(".card-information." + skuClass).find(".price").html(priceHtml);
                                skuClass = skuClass.replaceAll(".", "");
                                $(".card-information." + skuClass).find(".price__container").html(priceHtml);
                                //$(".price-item.price-item--regular.tpo_product_price").html(priceHtml);
                            }
                        } catch (err) {
                            console.log(err);
                        }
                    });
                    setCookie(sku, priceHtml, priceCookieTime.toUTCString());
                })
                .catch(error => console.error('Error:', error));
        }
        // Price Customization End

        // PDP Customizations Start
        var optionsJson = [];
        var count = 0;
        // Initialize Product JSON
        const isPDP = $(".is-pdp").val();
        const pdpSku = $(".pdp-sku").val();
        if (isPDP) {
            // move add to wishlist and add to compare into one element
            $("<div class='wishlist-compare'></div>").insertAfter($(".product-form").parent());
            $("#ZlistWishlist").parent().addClass('wishlist-block').appendTo(".wishlist-compare");
            $("div[id*='equate_product_block']").addClass('compare-block').appendTo(".wishlist-compare");
            // move qty and add to cart into one element
            $("<div class='qty-add-to-cart'></div>").insertAfter($(".usallyships"));
            $("div[id*='Quantity-Form-template']").addClass('qty-selector').appendTo(".qty-add-to-cart");
            $(".product-form.product-add-to-cart").parent().addClass('add-to-cart-wrapper').appendTo(".qty-add-to-cart");
        }
        if (isPDP && pdpSku) {
            searchProductOptions(pdpSku);
            checkShouldAddDefaultLable();
            addLabelsForDefaltOptions();

            //$(".easify-product-options").addClass('default-options');
            $(document).on('click', '.customize-pdp-options', function() {
                $(".easify-product-options").removeClass('default-options');
                $(this).hide();
            });
            $(document).on('click', '.tpo_buttons-wrapper .tpo_button_option_value', function() {
                $(this).closest('.tpo_option-label').find('.tpo_selected_values_span ').text('');
                var selectedOption = $(this).text();
                selectedOption = selectedOption.trim();
                if (selectedOption && $(this).parent().parent().hasClass('tpo_is_checked_swatches')) {
                    $(this).closest('.tpo_option-label').find('.tpo_selected_values_span ').text(selectedOption);
                }
                $(".tpo_add-to-cart").addClass('disabled').prop('disabled', true);
                $(".option-not-available").removeClass('hidden');
                setTimeout(updateProductVariantId(), 500);
            });
            $(document).on('click', '.tpo_buttons-wrapper .tpo_shape_square', function() {
                $(".tpo_add-to-cart").addClass('disabled').prop('disabled', true);
                $(".option-not-available").removeClass('hidden');
                setTimeout(updateProductVariantId(), 500);
            });
            $(document).on('click', '.tpo_color-swatches-wrapper .tpo_shape_square', function() {
                $(".tpo_add-to-cart").addClass('disabled').prop('disabled', true);
                $(".option-not-available").removeClass('hidden');
                setTimeout(updateProductVariantId(), 500);
            });
            $(document).on('click', '.tpo_image-swatches-wrapper .tpo_shape_square', function() {
                $(".tpo_add-to-cart").addClass('disabled').prop('disabled', true);
                $(".option-not-available").removeClass('hidden');
                setTimeout(updateProductVariantId(), 500);
            });
        }

        function searchProductOptions(sku) {
            var optionJsonCookie = getCookie('optionsJson' + sku);
            if (optionJsonCookie && useCookiesForGraphQLResponse) {
                optionsJson = JSON.parse(optionJsonCookie);
                return JSON.parse(optionJsonCookie);
            }
            const storefrontProductQuery = `
            {
              products(first: 250, query:"tag:` + sku + `") {
                edges {
                  node {
                    metafields(identifiers: [
                      {key: "size", namespace: "custom"},
                      {key: "frame_finish", namespace: "custom"},
                      {key: "fabrics", namespace: "custom"},
                      {key: "color", namespace: "custom"},
                      {key: "base", namespace: "custom"},
                      {key: "base_color", namespace: "custom"}
                    ]) {
                      key
                      value
                    }
                    variants(first: 10) {
                    edges {
                      node {
                        id
                        title
                        priceV2 {
                            amount
                          }
                          compareAtPrice {
                            amount
                          }
                        sku
                        availableForSale
                      }
                    }}
                    tags
                    id
                    title
                    handle
                    images(first: 1) {
                      edges {
                        node {
                          altText
                          originalSrc
                          transformedSrc(maxWidth: 800, maxHeight: 800)
                        }
                      }
                    }
                  }
                }
              }
            }
            `;

            const storefrontRequestforProductOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Shopify-Storefront-Access-Token': accessToken
                },
                body: JSON.stringify({
                    query: storefrontProductQuery
                }),
            };
            fetch(graphQlUrl, storefrontRequestforProductOptions)
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! Status: ${response.status}`);
                    }
                    return response.json();
                })
                .then(data => {
                    const productsData = data?.data?.products?.edges || []; // Safe access for products
                    productsData.forEach(eachCollection => {
                        try {
                            var matchingTag = false;
                            var tags = eachCollection.node.tags;
                            tags.forEach(tag => {
                                if (sku == tag) {
                                    matchingTag = true;
                                }
                            });
                            if (matchingTag) {
                                const nodeObj = eachCollection.node.variants.edges[0].node;
                                var variantId = nodeObj.id;
                                variantId = variantId.replace("gid://shopify/ProductVariant/", "");
                                const metaFields = eachCollection.node.metafields;
                                var varianData = {};
                                varianData.meta = metaFields;
                                varianData.option = nodeObj;
                                varianData.id = variantId;
                                varianData.image = eachCollection.node.images.edges[0].node.originalSrc;
                                optionsJson[count] = varianData;
                                count++;
                            }
                        } catch (err) {
                            console.log(err);
                        }
                    });
                    setCookie('optionsJson' + sku, JSON.stringify(optionsJson), optionsJsonCookieTime);
                    updateProductVariantId();
                })
                .catch(error => console.error('Error:', error));
        }

        function updateProductVariantId() {
            if (!$(".tpo_option-set-wrapper.tpo_has-option-set").length) {
                return false;
            }
            $(".product__inventory").removeClass('visibility-hidden');
            $(".product__inventory").removeClass('in-stock');
            $(".product__inventory").removeClass('out-of-stock');
            $(".product__inventory").html("");
            var count = 0;
            var selectedOption = [];
            $(".tpo_option-label .form__label").each(function() {
                var label = $(this).text();
                label = label.split(":");
                var key = label[0];
                key = key.trim();
                key = key.replaceAll(" ", "_");
                key = key.toLowerCase();
                key = String(key[0]).toUpperCase() + String(key).slice(1);
                var value = label[1];
                value = value.trim();
                if (key != 'Add_on') {
                    selectedOption[key] = value;
                    count++;
                }
            });
            optionsJson.forEach(option => {
                const meta = option.meta;
                mDataArray = [];
                meta.forEach(mData => {
                    if (mData) {
                        var mDataKey = mData.key;
                        mDataKey = String(mDataKey[0]).toUpperCase() + String(mDataKey).slice(1);
                        mDataKey = mDataKey.trim();
                        if (selectedOption[mDataKey]) {
                            var mDataValue = mData.value;
                            mDataValue = mDataValue.replaceAll('["', '');
                            mDataValue = mDataValue.replaceAll('"]', '');
                            mDataValue = String(mDataValue[0]).toUpperCase() + String(mDataValue).slice(1);
                            mDataValue = mDataValue.trim();
                            mDataArray[mDataKey] = mDataValue;
                        }
                    }
                });

                if (compareAssociativeArrays(mDataArray, selectedOption)) {
                    var priceObj = option.option.priceV2;
                    var price = false;
                    var specialPrice = false;
                    var specialPriceObj = option.option.compareAtPrice;
                    if (priceObj) {
                        price = priceObj.amount;
                        if (price) {
                            //price = (Math.round(price * 100) / 100).toFixed(2);
                            price = USDollar.format(price);
                        }
                    }
                    if (specialPriceObj) {
                        specialPrice = specialPriceObj.amount;
                        if (specialPrice) {
                            //specialPrice = (Math.round(specialPrice * 100) / 100).toFixed(2);
                            specialPrice = USDollar.format(specialPrice);
                        }
                    }
                    if (price) {
                        if (specialPrice) {
                            priceHtml = "<span class='strike-through'><span class='regular-price'>" + specialPrice + "</span></span><span class='special-price'>" + price + "</span>";
                        } else {
                            priceHtml = "<span><span class='regular-price'>" + price + "</span></span>";
                        }
                        $(".product__info-container .price__container").html(priceHtml);
                        /*$(".price-item.price-item--regular").html(priceHtml);
                        $(".price-item.price-item--regular").show();
                        $(".price-item.price-item--regular").css('visibility', 'visible');
                        $(".price-item.price-item--regular.tpo_product_price").html(priceHtml);
                        $(".price-item.price-item--regular.tpo_product_price").hide();*/
                    }
                    $(".product-variant-id").val(option['id']);
                    for (key in mDataArray) {
                        var keyLabel = key;
                        keyLabel = keyLabel.replaceAll("_", " ");
                        keyLabel = keyLabel.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
                        if ($('input[name="properties[' + keyLabel + ']"]').length > 0) {
                            $('input[name="properties[' + keyLabel + ']"]').val(mDataArray[key]);
                        }
                    }
                    if (option.option.availableForSale) {
                        $(".product__inventory").addClass('in-stock');
                        $(".product__inventory").html("<span class='svg-wrapper'></span>In Stock");
                        $(".tpo_add-to-cart").removeClass('disabled').prop('disabled', false);
                        $(".option-not-available").addClass('hidden');
                    } else {
                        $(".tpo_add-to-cart").addClass('disabled').prop('disabled', true);
                        $(".product__inventory").addClass('out-of-stock');
                        $(".product__inventory").html("<span class='svg-wrapper'></span>Out of Stock");
                    }
                    $(".page-width > .product .product__info-wrapper.grid__item .price__container").addClass('force-show');
                    var selectedProductImage = option.image;
                    $(".grid__item.product__media-wrapper ul.product__media-list li:first .product__media.pl-parent img").removeAttr('srcset');
                    $(".grid__item.product__media-wrapper ul.product__media-list li:first .product__media.pl-parent img").attr('src', selectedProductImage);
                }
            });
        }

        function nrKeys(a) {
            var i = 0;
            for (key in a) {
                i++;
            }
            return i;
        }

        function compareAssociativeArrays(a, b) {
            if (a == b) {
                return true;
            }
            if (nrKeys(a) != nrKeys(b)) {
                return false;
            }
            for (key in a) {
                if (a[key] != b[key]) {
                    return false;
                }
            }
            return true;
        }

        function checkShouldAddDefaultLable() {
            setTimeout(function() {
                if (!$(".tpo_option-set-wrapper").length) {
                    checkShouldAddDefaultLable();
                } else {
                    if ($(".tpo_option-set-wrapper").hasClass('tpo_has-option-set')) {
                        addLabelsForDefaltOptions();
                    } else {
                        $(".page-width > .product .product__info-wrapper.grid__item .price__container").addClass('force-show');
                    }
                }
            }, 200);
        }

        function addLabelsForDefaltOptions() {
            var triggerFlag = false;
            setTimeout(function() {
                if (!$(".tpo_option-label").length) {
                    addLabelsForDefaltOptions();
                }
                $(".tpo_option-label").each(function() {
                    var labelValue = $(this).find(".form__label").text();
                    labelValue = labelValue.trim();
                    if (!$(this).find('.tpo_selected_values_span').text() && labelValue.indexOf('Add on') != 0) {
                        var selectedOption = $(this).find('.tpo_is_checked_swatches').find('.tpo_button_option_value').text();
                        selectedOption = selectedOption.trim();
                        $(this).find('.tpo_selected_values_span').text(selectedOption);
                        if (!triggerFlag) {
                            triggerFlag = true;
                        }
                    }
                });
                if (triggerFlag) {
                    addLabelsForDefaltOptions();
                } else {
                    if ($('.tpo_option-set-wrapper').hasClass('tpo_has-option-set')) {
                        //if ($('.tpo_option-set-wrapper').hasClass('tpo_has-option-set') && !$('.customize-pdp-options').length) {
                        //$(".easify-product-options").parent().append("<div class='customize-pdp-options'>Customize Options</div>");
                        if (!$(".easify-product-options").parent().find(".option-not-available").length) {
                            $(".easify-product-options").parent().prepend("<div class='option-not-available hidden'>The selected variation is currently unavailable.</div>");
                        }
                        setTimeout(updateProductVariantId(), 500);
                    }
                }
            }, 500);
        }
        // PDP Customizations End
        $(document).ready(function() {
            // Pagination customization start
            /*const formData = new FormData()
            fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                body: formData
            })
            .then(response => response.json())
            .then(data => {
                if (!Object.hasOwn(data.attributes, 'collection_products_per_page')) {
                    const formData = new FormData();
                    formData.append("attributes[collection_products_per_page]", "12");
                    fetch(window.Shopify.routes.root + 'cart/update.js', {
                        method: 'POST',
                        body: formData
                    });
                }
            });*/

            $(document).on('change', '#products_per_page', function() {
                var perPage = $(this).val();
                var perPageData = '{"attributes":{"collection_products_per_page":"' + perPage + '"}}';
                $.ajax({
                    url: "/cart/update.js",
                    type: "post",
                    data: perPageData,
                    contentType: "application/json",
                    success: function(result) {
                        var queryParams = window.location.search;
                        if (queryParams.indexOf("page=")) {
                            const params = new URLSearchParams(window.location.search);
                            params.delete("page");
                            var newUrl = window.location.origin + window.location.pathname;
                            if (params.size) {
                                newUrl = newUrl + '?' + params;
                            }
                            window.location.href = newUrl;
                        } else {
                            location.reload();
                        }
                    }
                });
            });
            // URL sepecific default option start
            getUrlVars();

            function updateDefaultOption(urlParams) {
                setTimeout(function() {
                    if ($(".tpo_option-container").length) {
                        var availableLables = [];
                        $(".tpo_option-container").each(function() {
                            var conainerElement = $(this);
                            var label = $(this).find(".tpo_option-label .form__label").text();
                            var selectedValue = $(this).find(".tpo_option-label .tpo_selected_values_span ").text();
                            selectedValue = selectedValue.trim();
                            label = label.replaceAll(selectedValue, "");
                            label = label.trim();
                            label = label.replaceAll(" ", "_");
                            label = label.replaceAll(":", "");
                            label = label.toLowerCase();
                            label = label.trim();
                            selectedValue = selectedValue.replaceAll(" ", "_");
                            selectedValue = selectedValue.toLowerCase();
                            for (var key in urlParams) {
                                if (urlParams[key] && key == label && urlParams[key] != selectedValue) {
                                    $(this).find('label').each(function() {
                                        var currentElementValue = $(this).text();
                                        currentElementValue = currentElementValue.trim();
                                        var currentElementValueOriginal = currentElementValue;
                                        currentElementValue = currentElementValue.replaceAll(" ", "_");
                                        currentElementValue = currentElementValue.toLowerCase();
                                        if (!currentElementValue) {
                                            currentElementValue = $(this).find('input').val();
                                            currentElementValueOriginal = currentElementValue;
                                            currentElementValue = currentElementValue.replaceAll(" ", "_");
                                            currentElementValue = currentElementValue.toLowerCase();
                                        }
                                        if (urlParams[key] == currentElementValue) {
                                            conainerElement.find('label').removeClass('tpo_is_checked_swatches');
                                            //conainerElement.find('label').find('input').removeClass('tpo_checked');
                                            //$(this).parent().trigger('click');
                                            conainerElement.find('input').prop('checked', false);
                                            $(this).find('input').click();
                                            $(this).addClass('tpo_is_checked_swatches');
                                            $(this).find('input').addClass('tpo_checked');
                                            $(this).parent().parent().parent().find('.tpo_selected_values_span').text(currentElementValueOriginal);
                                            $(".tpo_add-to-cart").addClass('disabled').prop('disabled', true);
                                            $(".option-not-available").removeClass('hidden');
                                            setTimeout(updateProductVariantId(), 1000);
                                        }
                                    });

                                }
                            }
                        });
                    } else {
                        updateDefaultOption(urlParams);
                    }
                }, 500);
            }

            function getUrlVars() {
                var vars = [],
                    hash;
                var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
                for (var i = 0; i < hashes.length; i++) {
                    hash = hashes[i].split('=');
                    if (hash[0] == '_pos') {
                        continue;
                    }
                    if (hash[0] == '_fid') {
                        continue;
                    }
                    if (hash[0] == '_ss') {
                        continue;
                    }
                    vars.push(hash[0]);
                    vars[hash[0]] = hash[1];
                }
                updateDefaultOption(vars);
            }
            // URL specific default option end

            $('.storeify-section-header label.back-stores a').attr('href', '/pages/find-an-authorized-dealer');
            // hide empty tabs on PDP
            $(".product__accordion.accordion.quick-add-hidden").each(function() {
                if ($(this).find(".accordion__content").text().trim() == '') {
                    $(this).addClass('hidden');
                }
            });
            const $tooltipTrigger = $(".tooltipClick");
            const $tooltipSection = $(".tooltipContentSection");
            const $overlay = $(".tooltipoverlay");
            const $closeBtn = $(".close-btn");
            const $bodyClass = $("body");

            // Open Tooltip on Click
            $(document).on('click', '.tpo_option-tooltip-icon', function() {
                var tooltipClass = $(this).data('tooltip');
                if (tooltipClass) {
                    $(".tooltipContentSection .tooltipContentblock").addClass('hidden');
                    $(".tooltipContentSection .tooltipContentblock." + tooltipClass).removeClass('hidden');
                    $tooltipSection.addClass("active");
                    $overlay.addClass("active");
                    $bodyClass.addClass("hidescroll");
                }
            });

            // Close Tooltip on Overlay Click
            $overlay.on("click", function() {
                $(".tooltipContentSection .tooltipContentblock").addClass('hidden');
                $tooltipSection.removeClass("active");
                $overlay.removeClass("active");
                $bodyClass.removeClass("hidescroll");
            });
            /// Close Tooltip on Overlay Click
            $closeBtn.on("click", function() {
                $(".tooltipContentSection .tooltipContentblock").addClass('hidden');
                $tooltipSection.removeClass("active");
                $overlay.removeClass("active");
                $bodyClass.removeClass("hidescroll");
            });
        });
        // Location Page Search
        //$("#reset-search").text('Reset');
        const urlParams = new URLSearchParams(window.location.search);
        const zip = urlParams.get('zip');
        if (zip) {
            const pageUrl = window.location.href;
            if (pageUrl.indexOf("pages/find-an-authorized-dealer?zip=") != -1) {
                $("#results-slt").addClass('hidden');
                $(".map_container.top.search-map").addClass('hidden');
            }
            var storesListFlag = false;
            window.storesListFlag = false;
            triggerStoreSearch();

            function triggerStoreSearch() {
                setTimeout(function() {
                    const addressInput = document.getElementById('address');
                    const submitButton = document.getElementById('submit-search');

                    if (addressInput && submitButton) {
                        addressInput.value = zip;
                        submitButton.click();
                        if (parseInt($("h3.title #num-rs").text()) !== window.storesListFlag) {
                            window.storesListFlag = parseInt($("h3.title #num-rs").text());
                            triggerStoreSearch();
                        }
                        setTimeout(function() {
                            if (parseInt($("h3.title #num-rs").text()) === window.storesListFlag) {
                                $("#results-slt").removeClass('hidden');
                                $(".map_container.top.search-map").removeClass('hidden');
                            }
                        }, 500);
                    }
                }, 500);
            }
        }

    });
})(jQuery);